var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""},on:{"enter":_vm.getAnimateIn,"leave":_vm.getAnimateOut}},[(_vm.open)?_c('div',{staticClass:"simple-panel-wrapper"},[_c('div',{staticClass:"simple-panel"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }